/* src/app/components/billing/global-ledger/view-global-ledger/view-global-ledger.component.css */
/*# sourceMappingURL=view-global-ledger.component-WJ5ENAHP.css.map */
